'use client'
import '@mantine/carousel/styles.css'

import { ActionIcon } from '@mantine/core'
import { useState } from 'react'

import IconArrowLeft from '@/assets/icons/arrow-left.svg'
import IconArrowRight from '@/assets/icons/arrow-right.svg'
import palette from '@/styles/palette'

interface CarouselButtonProps {
  direction: 'prev' | 'next'
  disabled: boolean
  onClick: () => void
}

export default function CarouselButton({ direction, disabled, onClick }: CarouselButtonProps) {
  const [isHover, setIsHover] = useState(false)
  const Icon = direction === 'prev' ? IconArrowLeft : IconArrowRight

  return (
    <ActionIcon
      variant="transparent"
      size={32}
      onClick={onClick}
      disabled={disabled}
      bg="none"
      c={palette.grey[300]}
      style={{
        opacity: disabled ? 0.4 : 1,
        transition: 'opacity 0.2s',
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Icon
        style={{ width: 24, height: 24 }}
        fill={isHover ? 'var(--common-white)' : 'var(--text-secondary)'}
      />
    </ActionIcon>
  )
}
